import React, { Component } from 'react';
import{ HistoryLayout } from "../../../../../common/history/history-layout.component";
import { TablePagination } from '../../../../../common/details-table/table-pagination.component';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { billingAccountHistoryActions } from "../../../../../../store/external/finance/billing-account/billing-account-history.reducer";
import { Loading } from '../../../../../common/loading';
import { MODAL_CUSTOM_MESSAGE } from "../../../../../../constants/external-constants";

class BillingHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            enableSearchBox: false,
            isLoading: true,
            exportAlertMsg: MODAL_CUSTOM_MESSAGE.export_alert_message,
        }
    }

    componentDidMount() {
        const { getBillingAccountHistoryLogs, financeAccountID } = this.props;

        getBillingAccountHistoryLogs(financeAccountID)
            .then(() => {
                this.setState({ isLoading: false })
            });
    }

    componentWillUnmount() {
        this.props.resetBillingAccountHistory();
    }

    getTableData(pageIndex) {
        this.props.getBillingAccountHistoryLogs(this.props.financeAccountID, pageIndex);
    }

    resizePage = (pageSize) => {
        const { resizeBillingAccountHistoryLogs, getBillingAccountHistoryLogs, financeAccountID } = this.props;
        resizeBillingAccountHistoryLogs(pageSize)

        this.setState({ isLoading: true });

        getBillingAccountHistoryLogs(financeAccountID)
            .then(() => {
                this.setState({ isLoading: false })
            });
    }

    billingAccountPaginationAction = (pageIndex) => {
        const { getBillingAccountHistoryLogs, financeAccountID } = this.props;

        getBillingAccountHistoryLogs(financeAccountID, pageIndex)
    }

    onColumnSearch = () => {
        const { getBillingAccountHistoryLogs, financeAccountID } = this.props;

        getBillingAccountHistoryLogs(financeAccountID, 0);
    }

    displaySearchBox = (value) => {
        this.setState({ enableSearchBox: value })
    }

    onClickExtract = () => {
        const { financeAccountID, extractBillingAccountHistoryLogs } = this.props;
        if (window.confirm(this.state.exportAlertMsg)) {
            extractBillingAccountHistoryLogs(financeAccountID);
        }
    }  

    render() {
        const { setBillingAccountColSearchStr, isReadOnly, isReadAndExtractOnly, isReadAndWrite } = this.props;
        const { Headers, Data, Pagination } = this.props.billingAccountHistory.HistoryTable;
        return (
            <div>
            <HistoryLayout
             displaySearchBox={this.displaySearchBox}
             extractAction={this.onClickExtract}

            //Access Type
            isReadOnly={isReadOnly}
            isReadAndExtractOnly={isReadAndExtractOnly}
            isReadAndWrite={isReadAndWrite} 
            hideCustomColumn={true}
            >
                <TablePagination
                    key="table-pagination-key"
                    columns={Headers}
                    pageList={Data}                 
                    pages={Pagination}
                    paginationAction={this.billingAccountPaginationAction}
                    onColumnSearch={() => { this.onColumnSearch() }}
                    onColumnSearchChange={setBillingAccountColSearchStr}
                    isColSearchShow={this.state.enableSearchBox}
                    resizePage={this.resizePage}
                    totalPage={Pagination.TotalEntries}
                    isNotSortable={true}
                    isLoading={this.state.isLoading}   
                />
            </HistoryLayout>
        </div>
        );
    }
}

export default connect(
    state => {
        const { billingAccountHistory } = state;

        return {
            billingAccountHistory
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, billingAccountHistoryActions),
        dispatch
    )
)(BillingHistory);
